var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"personnelImproved"},[_c('div',{staticClass:"department"},[_c('div',{attrs:{"id":"department_num"}}),_c('p',[_vm._v("运动队数："+_vm._s(_vm.departemtnNum)+"个")])]),_c('div',{attrs:{"id":"jobs_num"}}),_c('div',{attrs:{"id":"degree_distribution"}}),_c('div',{attrs:{"id":"age_structure"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }